// extracted by mini-css-extract-plugin
export default {"share_button":"PositionDetails_share_button__PEr-m","social_media_links":"PositionDetails_social_media_links__g2BYr"};